import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { memo } from "react";
import { MonthView } from "react-calendar";
import { addMonths, eachMonthOfInterval, max, min, subMonths } from "date-fns";
import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import { useCalendar } from "../../../../services/hooks/index.js";
import { Tooltip } from "../../../../Tooltip/index.js";
import { DropdownButton } from "../../../../DropdownButton/index.js";
import { MenuItem } from "../../../../MenuItem/index.js";
import { Typography } from "../../../../Typography/index.js";
import { Link } from "../../../../Link/index.js";
import { Box } from "../../../../Box/index.js";
import { Icon } from "../../../../Icon/index.js";
import { useIsDesktop } from "../../../../hooks/index.js";
import Month_styles from "./Month.styles.js";
const Month = /*#__PURE__*/ memo((t0)=>{
    const $ = c(78);
    const { year, month, value, onChange, minDate, maxDate, createTooltipText, shouldDisableDate, onDelete, holidays, regionalHolidays, hoverDate, setHoverDate, range, readonly, disabled, onRangeClick, clearable, onClear, deletedRanges, compensationRanges, blockedRanges, testId } = t0;
    const { classes } = Month_styles();
    const calendar = useCalendar();
    const isDesktop = useIsDesktop();
    let activeStartDate;
    let t1;
    if ($[0] !== month || $[1] !== year) {
        activeStartDate = new Date(year, month);
        const monthName = activeStartDate.toLocaleString("ru-RU", {
            month: "long"
        });
        t1 = monthName.replace(monthName[0], monthName[0].toUpperCase());
        $[0] = month;
        $[1] = year;
        $[2] = activeStartDate;
        $[3] = t1;
    } else {
        activeStartDate = $[2];
        t1 = $[3];
    }
    const formattedMonthName = t1;
    let t2;
    if ($[4] !== onClear) {
        t2 = ()=>{
            if (onClear) onClear();
        };
        $[4] = onClear;
        $[5] = t2;
    } else t2 = $[5];
    const handleClear = t2;
    let t3;
    if ($[6] !== calendar || $[7] !== createTooltipText || $[8] !== hoverDate || $[9] !== isDesktop || $[10] !== onDelete || $[11] !== onRangeClick || $[12] !== range[0] || $[13] !== setHoverDate || $[14] !== value) {
        t3 = (t4)=>{
            const { date } = t4;
            const clickedRange = null == value ? void 0 : value.find((selectedRange)=>date >= selectedRange[0] && date <= selectedRange[1]);
            const handleRangeClick = ()=>{
                if (onRangeClick && clickedRange) onRangeClick(clickedRange);
            };
            const onDateClick = ()=>{
                if (!range[0]) setHoverDate(date);
            };
            const onMouseEnter = ()=>{
                if (range[0]) setHoverDate(date);
            };
            const onMouseLeave = ()=>{
                if (date && !range[0] && hoverDate && calendar.isSameDay(date, hoverDate)) setHoverDate(null);
            };
            const tooltipText = createTooltipText ? createTooltipText(date) : "";
            const dayTestId = `year-calendar-input-day-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
            if (!!clickedRange && onRangeClick) return /*#__PURE__*/ jsx(Tooltip, {
                placement: "top",
                title: tooltipText,
                disabled: !tooltipText,
                children: /*#__PURE__*/ jsx("span", {
                    children: /*#__PURE__*/ jsx(DropdownButton, {
                        variant: "quaternary",
                        verticalPosition: "bottom",
                        horizontalPosition: "right",
                        button: (t5)=>{
                            const { onClick } = t5;
                            return /*#__PURE__*/ jsx("div", {
                                "data-testid": dayTestId,
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: 32,
                                    height: 32
                                },
                                onClick: (e)=>{
                                    onClick(e);
                                    handleRangeClick();
                                },
                                onMouseEnter: onMouseEnter,
                                onMouseLeave: onMouseLeave
                            });
                        },
                        menuItems: [
                            /*#__PURE__*/ jsx(MenuItem, {
                                onClick: ()=>onDelete(date),
                                children: isDesktop ? "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D" : /*#__PURE__*/ jsxs(Box, {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8",
                                    children: [
                                        /*#__PURE__*/ jsx(Icon, {
                                            name: "delete_outline",
                                            size: "16",
                                            color: "text.light.primary"
                                        }),
                                        /*#__PURE__*/ jsx(Box, {
                                            children: "Удалить диапазон"
                                        })
                                    ]
                                })
                            }, "1")
                        ]
                    })
                })
            });
            return /*#__PURE__*/ jsx(Tooltip, {
                placement: "top",
                title: tooltipText,
                disabled: !tooltipText,
                children: /*#__PURE__*/ jsx("div", {
                    "data-testid": dayTestId,
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: 32,
                        height: 32
                    },
                    onClick: onDateClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                })
            });
        };
        $[6] = calendar;
        $[7] = createTooltipText;
        $[8] = hoverDate;
        $[9] = isDesktop;
        $[10] = onDelete;
        $[11] = onRangeClick;
        $[12] = range[0];
        $[13] = setHoverDate;
        $[14] = value;
        $[15] = t3;
    } else t3 = $[15];
    const createTileContent = t3;
    let t4;
    if ($[16] !== blockedRanges || $[17] !== calendar || $[18] !== classes.blockedRangeDay || $[19] !== classes.blockedRangeDayEnd || $[20] !== classes.blockedRangeDayStart || $[21] !== classes.compensationRangeDay || $[22] !== classes.compensationRangeDayEnd || $[23] !== classes.compensationRangeDayStart || $[24] !== classes.day || $[25] !== classes.deletedRangeDay || $[26] !== classes.deletedRangeDayEnd || $[27] !== classes.deletedRangeDayStart || $[28] !== classes.holiday || $[29] !== classes.rangeEnd || $[30] !== classes.rangeStart || $[31] !== classes.readOnly || $[32] !== classes.regionalHoliday || $[33] !== classes.selectedRangeDay || $[34] !== classes.selectedRangeDayEnd || $[35] !== classes.selectedRangeDayStart || $[36] !== compensationRanges || $[37] !== deletedRanges || $[38] !== holidays || $[39] !== hoverDate || $[40] !== range[0] || $[41] !== readonly || $[42] !== regionalHolidays || $[43] !== shouldDisableDate || $[44] !== value) {
        t4 = (t5)=>{
            const { date: date_0 } = t5;
            let classname = `${classes.day}`;
            const isInRange = !!date_0 && !!range[0] && !!hoverDate && (date_0 >= range[0] && date_0 <= hoverDate || date_0 >= hoverDate && date_0 <= range[0]);
            const isRangeStart = isInRange && date_0 && range[0] && hoverDate && (calendar.isSameDay(date_0, range[0]) && hoverDate >= range[0] || calendar.isSameDay(date_0, hoverDate) && hoverDate < range[0]);
            if (isInRange) classname = `${classname} ${classes.selectedRangeDay}`;
            if (isRangeStart) classname = `${classname} ${classes.rangeStart}`;
            if (!(shouldDisableDate ? shouldDisableDate(date_0, range[0]) : false)) {
                const isRangeEnd = isInRange && date_0 && range[0] && hoverDate && (calendar.isSameDay(date_0, hoverDate) && range[0] <= hoverDate || calendar.isSameDay(date_0, range[0]) && range[0] > hoverDate);
                if (isRangeEnd) classname = `${classname} ${classes.rangeEnd}`;
                null == value || value.forEach((selectedRange_0)=>{
                    if (!isInRange && date_0 >= selectedRange_0[0] && date_0 <= selectedRange_0[1]) {
                        classname = `${classname} ${classes.selectedRangeDay}`;
                        if (calendar.isSameDay(date_0, selectedRange_0[0])) classname = `${classname} ${classes.selectedRangeDayStart}`;
                        if (calendar.isSameDay(date_0, selectedRange_0[1])) classname = `${classname} ${classes.selectedRangeDayEnd}`;
                    }
                });
            }
            null == holidays || holidays.forEach((holiday)=>{
                if (calendar.isSameDay(date_0, holiday)) classname = `${classname} ${classes.holiday}`;
            });
            null == regionalHolidays || regionalHolidays.forEach((regionalHoliday)=>{
                if (calendar.isSameDay(date_0, regionalHoliday)) classname = `${classname} ${classes.regionalHoliday}`;
            });
            null == deletedRanges || deletedRanges.forEach((deleted)=>{
                if (date_0 >= deleted[0] && date_0 <= deleted[1] && !range[0]) {
                    classname = `${classname} ${classes.deletedRangeDay}`;
                    if (calendar.isSameDay(date_0, deleted[0]) && !range[0]) classname = `${classname} ${classes.deletedRangeDayStart}`;
                    if (calendar.isSameDay(date_0, deleted[1]) && !range[0]) classname = `${classname} ${classes.deletedRangeDayEnd}`;
                }
            });
            null == compensationRanges || compensationRanges.forEach((compensationRange)=>{
                if (date_0 >= compensationRange[0] && date_0 <= compensationRange[1]) {
                    classname = `${classname} ${classes.compensationRangeDay}`;
                    if (calendar.isSameDay(date_0, compensationRange[0])) classname = `${classname} ${classes.compensationRangeDayStart}`;
                    if (calendar.isSameDay(date_0, compensationRange[1])) classname = `${classname} ${classes.compensationRangeDayEnd}`;
                }
            });
            null == blockedRanges || blockedRanges.forEach((blocked)=>{
                if (date_0 >= blocked[0] && date_0 <= blocked[1]) {
                    classname = `${classname} ${classes.blockedRangeDay}`;
                    if (calendar.isSameDay(date_0, blocked[0])) classname = `${classname} ${classes.blockedRangeDayStart}`;
                    if (calendar.isSameDay(date_0, blocked[1])) classname = `${classname} ${classes.blockedRangeDayEnd}`;
                }
            });
            if (readonly) classname = `${classname} ${classes.readOnly}`;
            return classname;
        };
        $[16] = blockedRanges;
        $[17] = calendar;
        $[18] = classes.blockedRangeDay;
        $[19] = classes.blockedRangeDayEnd;
        $[20] = classes.blockedRangeDayStart;
        $[21] = classes.compensationRangeDay;
        $[22] = classes.compensationRangeDayEnd;
        $[23] = classes.compensationRangeDayStart;
        $[24] = classes.day;
        $[25] = classes.deletedRangeDay;
        $[26] = classes.deletedRangeDayEnd;
        $[27] = classes.deletedRangeDayStart;
        $[28] = classes.holiday;
        $[29] = classes.rangeEnd;
        $[30] = classes.rangeStart;
        $[31] = classes.readOnly;
        $[32] = classes.regionalHoliday;
        $[33] = classes.selectedRangeDay;
        $[34] = classes.selectedRangeDayEnd;
        $[35] = classes.selectedRangeDayStart;
        $[36] = compensationRanges;
        $[37] = deletedRanges;
        $[38] = holidays;
        $[39] = hoverDate;
        $[40] = range[0];
        $[41] = readonly;
        $[42] = regionalHolidays;
        $[43] = shouldDisableDate;
        $[44] = value;
        $[45] = t4;
    } else t4 = $[45];
    const createTileClassName = t4;
    let t5;
    if ($[46] !== formattedMonthName) {
        t5 = /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle2",
            children: formattedMonthName
        });
        $[46] = formattedMonthName;
        $[47] = t5;
    } else t5 = $[47];
    let t6;
    if ($[48] !== clearable || $[49] !== handleClear) {
        t6 = clearable && /*#__PURE__*/ jsx(Link, {
            stroke: false,
            onClick: handleClear,
            children: "Сбросить"
        });
        $[48] = clearable;
        $[49] = handleClear;
        $[50] = t6;
    } else t6 = $[50];
    let t7;
    if ($[51] !== classes.monthName || $[52] !== t5 || $[53] !== t6) {
        t7 = /*#__PURE__*/ jsxs("div", {
            className: classes.monthName,
            children: [
                t5,
                t6
            ]
        });
        $[51] = classes.monthName;
        $[52] = t5;
        $[53] = t6;
        $[54] = t7;
    } else t7 = $[54];
    let t8;
    if ($[55] !== blockedRanges || $[56] !== calendar || $[57] !== disabled || $[58] !== range[0] || $[59] !== shouldDisableDate || $[60] !== value) {
        t8 = (t9)=>{
            const { date: date_1 } = t9;
            const isBlocked = (null == blockedRanges ? void 0 : blockedRanges.some((blocked_0)=>date_1 >= blocked_0[0] && date_1 <= blocked_0[1])) && !(value && calendar.isWithinIntervals(date_1, value));
            if (isBlocked) return !!range[0];
            if (disabled) return value ? !calendar.isWithinIntervals(date_1, value) : true;
            return shouldDisableDate ? shouldDisableDate(date_1, range[0]) : false;
        };
        $[55] = blockedRanges;
        $[56] = calendar;
        $[57] = disabled;
        $[58] = range[0];
        $[59] = shouldDisableDate;
        $[60] = value;
        $[61] = t8;
    } else t8 = $[61];
    let t9;
    if ($[62] !== activeStartDate || $[63] !== createTileClassName || $[64] !== createTileContent || $[65] !== maxDate || $[66] !== minDate || $[67] !== onChange || $[68] !== range || $[69] !== t8) {
        t9 = /*#__PURE__*/ jsx(MonthView, {
            showFixedNumberOfWeeks: true,
            showNeighboringMonth: true,
            valueType: "day",
            activeStartDate: activeStartDate,
            value: range,
            locale: "ru",
            onClick: onChange,
            minDate: minDate,
            maxDate: maxDate,
            tileClassName: createTileClassName,
            tileContent: createTileContent,
            tileDisabled: t8
        });
        $[62] = activeStartDate;
        $[63] = createTileClassName;
        $[64] = createTileContent;
        $[65] = maxDate;
        $[66] = minDate;
        $[67] = onChange;
        $[68] = range;
        $[69] = t8;
        $[70] = t9;
    } else t9 = $[70];
    let t10;
    if ($[71] !== classes.root || $[72] !== t9) {
        t10 = /*#__PURE__*/ jsx("div", {
            className: classes.root,
            children: t9
        });
        $[71] = classes.root;
        $[72] = t9;
        $[73] = t10;
    } else t10 = $[73];
    let t11;
    if ($[74] !== t10 || $[75] !== t7 || $[76] !== testId) {
        t11 = /*#__PURE__*/ jsxs("div", {
            "data-testid": testId,
            children: [
                t7,
                t10
            ]
        });
        $[74] = t10;
        $[75] = t7;
        $[76] = testId;
        $[77] = t11;
    } else t11 = $[77];
    return t11;
}, (prev, next)=>isEqual(omit(prev, 'hoverDate', 'range'), omit(next, 'hoverDate', 'range')) && !(!prev.hoverDate || !prev.range[0] || eachMonthOfInterval({
        start: subMonths(min([
            prev.hoverDate,
            next.hoverDate,
            prev.range[0],
            next.range[0]
        ].filter((date)=>!!date)), 1),
        end: addMonths(max([
            prev.hoverDate,
            next.hoverDate,
            prev.range[0],
            next.range[0]
        ].filter((date)=>!!date)), 1)
    }).map((date)=>date.getMonth()).includes(next.month)));
export { Month };
